import { uuid } from "uuidv4"
import { trackEvent } from "./serverSide"
import { addCinemaFieldsToEventData, dataLayerPush } from "../analytics";
import { CinemaType, LoyaltyPackageType } from "../../types/entities";

export const trackPackagesPurchaseLoad = (cinema: CinemaType, packages: LoyaltyPackageType[]) => {
    const metaEventData = {
        content_ids: [`packages_${cinema.id}`],
        content_type: 'product',
        content_name: `Packages ${cinema.name}`,
        currency: 'MXN',
        value: 0,
        content_category: 'Loyalty Program > Packages',
    };

    addCinemaFieldsToEventData(metaEventData, cinema);

    trackEvent(
        'ViewContent',
        uuid(),
        metaEventData
    );

    const googleEvent = {
        event: 'view_item_list',
        currency: metaEventData.currency,
        value: metaEventData.value,
        item_list_name: metaEventData.content_name,
        items: packages.map(pkg => ({
            item_id: `package_${pkg.id}`,
            item_name: `${pkg.name} - ${cinema.name}`
        }))
    };

    dataLayerPush(googleEvent);
};

export const trackPackagesPurchaseOptionSelect = (cinema: CinemaType, packages: LoyaltyPackageType[]) => {
    const metaEventData = {
        content_name: `Package ${packages.map(pkg => pkg.name).join(', ')} - ${cinema.name}`,
    };

    addPackagesFieldsToMetaEventData(metaEventData, cinema, packages);
    addCinemaFieldsToEventData(metaEventData, cinema);

    trackEvent(
        'AddToCart',
        uuid(),
        metaEventData
    );

    const googleEvent = {
        event: 'add_to_cart'
    };

    addPackagesFieldsToGoogleEventData(googleEvent, packages);
    dataLayerPush(googleEvent);
};

export const trackPackagesPurchaseComplete = (cinema: CinemaType, packages: LoyaltyPackageType[], successData: any) => {
    const metaEventData = {
        content_name: `Purchase Package ${packages.map(pkg => pkg.name).join(', ')} - ${cinema.name}`,
    };

    addPackagesFieldsToMetaEventData(metaEventData, cinema, packages);
    addCinemaFieldsToEventData(metaEventData, cinema);

    trackEvent(
        'Purchase',
        uuid(),
        metaEventData
    );
    
    const googleEvent = {
        event: 'purchase',
        transaction_id: `package_${successData.transaction_id}`
    };

    addPackagesFieldsToGoogleEventData(googleEvent, packages);
    dataLayerPush(googleEvent);
};

function addPackagesFieldsToMetaEventData(eventData: { [key: string]: any }, cinema: CinemaType, packages: LoyaltyPackageType[]) {
    eventData.content_ids = packages.map(pkg => `package_${pkg.id}`);
    eventData.content_type = 'product';
    eventData.currency = 'MXN';
    eventData.value = packages.reduce((total, pkg) => total + pkg.price, 0);
    eventData.content_category = 'Loyalty Program > Packages';
}

function addPackagesFieldsToGoogleEventData(googleEvent: { [key: string]: any }, packages: LoyaltyPackageType[]) {
    googleEvent.currency = 'MXN';
    googleEvent.value = packages.reduce((total, pkg) => total + pkg.price, 0);
    googleEvent.items = packages.map(pkg => ({
        item_id: `package_${pkg.id}`,
        item_name: pkg.name,
        quantity: 1,
        price: pkg.price
    }));
}